import { render, staticRenderFns } from "./ScoreEditor.vue?vue&type=template&id=f31364da&scoped=true"
import script from "./ScoreEditor.vue?vue&type=script&lang=js"
export * from "./ScoreEditor.vue?vue&type=script&lang=js"
import style0 from "./ScoreEditor.vue?vue&type=style&index=0&id=f31364da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31364da",
  null
  
)

export default component.exports